<style scoped lang="scss" type="text/scss">
    .team-item-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #FFF;

        .team-badge-container {
            width: 9.5rem;
            height: 9.5rem;
            margin: 1.5rem 0;
        }

        .text-panel {
            flex: 1;
            width: 100%;
            box-sizing: border-box;
            padding: .3rem 1rem .5rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: rgba(0, 0, 0, .85);

            .team-name {
                height: 1.5rem;
                margin-bottom: .3rem;
                line-height: 2rem;
                font-size: 1rem;
                width: 100%;
                text-align: center;
                color: #DDD;
            }

            .school-name {
                height: 1rem;
                line-height: 1rem;
                font-size: .75rem;
                margin-top: .3rem;
                width: 100%;
                text-align: center;
                color: #AAA;
            }

            .manager-name {
                height: 1rem;
                line-height: 1rem;
                font-size: .75rem;
                margin-top: .3rem;
                color: #AAA;
            }
        }
    }
</style>

<template>
    <functional-card class="team-item-container"
                     @call-edit="callEdit" @call-remove="callRemove"
    >
        <normal-image class="team-badge-container" :src="teamBadge"
                      :circular="true">
        </normal-image>

        <div class="text-panel">
            <div class="team-name global-text-ellipsis" :title="teamName">{{ teamName }}</div>
            <div class="manager-name">{{ managerName || '@暂未指定管理者@' }}</div>
            <div class="school-name global-text-ellipsis" :title="schoolName">{{ schoolName }}</div>
        </div>
    </functional-card>
</template>

<script>
    import FunctionalCard from '../../../../components/functional-card/index';
    import NormalImage from '../../../../components/normal-image/index';
    import _ from 'lodash';
    import {getName} from '../../../../utils/getter-helper';

    export default {
        name: '',
        props: {
            info: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        components: {
            NormalImage,
            FunctionalCard
        },
        data () {
            return {};
        },
        computed: {
            imagePlaceholder () {
                return this.$store.state.imagePlaceholder;
            },
            teamName () {
                return _.get(this.info, 'name', null);
            },
            schoolName () {
                return _.get(this.info, 'school.name', null);
            },
            managerName () {
                return getName(this.info.manager);
            },
            teamBadge () {
                return _.get(this.info, 'badge.url', this.imagePlaceholder);
            }
        },
        methods: {
            callEdit (callback) {
                this.$emit('call-edit', callback);
            },
            callRemove (callback) {
                this.$emit('call-remove', callback);
            }
        }
    };
</script>
